import { CVSS_SEVERITY_REASON_REQUIRED_MESSAGE } from '@terra/shared-cvss';
import { getCvssReasonsSaveError } from './FindingEditDrawerCvssSection';
import { resolveFindingEditCvssBaseline } from './finding-edit-cvss-baseline';
import type { EditableFields } from './finding-editable-fields';
import { isSeverityReasonMissing } from './finding-severity-reason';

export const getFindingEditExplanationError = ({
  editableFields,
  originalFields,
  cvssVersion,
}: {
  editableFields: EditableFields;
  originalFields: EditableFields;
  cvssVersion: string | null | undefined;
}): string | null => {
  if (
    isSeverityReasonMissing({
      severity: editableFields.severity,
      originalSeverity: originalFields.severity,
      severityReason: editableFields.severityReason,
    })
  ) {
    return CVSS_SEVERITY_REASON_REQUIRED_MESSAGE;
  }

  const baseline40 = resolveFindingEditCvssBaseline({
    editableFields,
    originalFields,
    cvssVersion,
    version: '4.0',
  });
  const baseline31 = resolveFindingEditCvssBaseline({
    editableFields,
    originalFields,
    cvssVersion,
    version: '3.1',
  });

  return (
    getCvssReasonsSaveError({
      next: baseline40.next,
      original: baseline40.original,
    }) ??
    getCvssReasonsSaveError({
      next: baseline31.next,
      original: baseline31.original,
    })
  );
};
